import React from 'react';

const DashboardHome = () => {
    return (
        <div>
            <h2>This is Dashboar Home</h2>
        </div>
    );
};

export default DashboardHome;